import React from 'react';
import { Activity, P } from '@fashionnovateam/nova-ui-toolkit';
import {
  type OpenChatEventParams,
  type ReorderWorksheetActivity,
} from '../../../../../Lib/Api/types/reorder-chat';

type OpenChatActivityProps = {
  activity: ReorderWorksheetActivity;
  isLast: boolean;
};

export function OpenChatActivity({ activity, isLast }: OpenChatActivityProps) {
  const { author, created_at: createdAt, event_params: eventParams } = activity;
  const params = eventParams as OpenChatEventParams;

  const isInternal = author.type === 'internal';
  const displayName = isInternal ? 'Fashion Nova' : author.name;
  const badgeType = isInternal ? 'fn_internal' : 'vendor';

  const mainContent = (
    <span className="text-base-secondary"> opened a negotiation.</span>
  );

  const detailContent = (
    <div className="flex flex-col gap-3">
      {params.reasons && params.reasons.length > 0 && (
        <div className="flex flex-col gap-1">
          <P size="xs" color="disabled">
            Improvements requested:
          </P>
          <div className="flex gap-1 flex-wrap">
            {params.reasons.map((reason) => (
              <span
                key={reason}
                className="bg-[#C97118] text-white nu-text-2xs px-2 py-1 rounded"
              >
                {reason}
              </span>
            ))}
          </div>
        </div>
      )}

      {params.comment && (
        <P size="xs" color="disabled">
          &quot;{params.comment}&quot;
        </P>
      )}
    </div>
  );

  return (
    <Activity
      name={displayName}
      badgeType={badgeType}
      hideBar={isLast}
      className="w-full !max-w-full"
    >
      <Activity.EventDetailed
        name={displayName}
        date={createdAt}
        text={mainContent}
        className="w-full"
        tooltipZIndex={100}
      >
        {detailContent}
      </Activity.EventDetailed>
    </Activity>
  );
}
